import React, { ReactNode } from "react";

import classNames from "classnames";

import { AnyObject } from "../../interfaces/anyObject";
import NavigationLink from "../navigationLink/navigationLink";

import "./subNavPoint.scss";

interface SubNavPointProps extends AnyObject {
  className?: string;
  color?: "black" | "white";
  children: ReactNode;
}

const SubNavPoint: React.FC<SubNavPointProps> = ({
  className = undefined,
  color = "black",
  children,
  ...otherProps
}) => (
  <NavigationLink
    {...otherProps}
    className={classNames("sub-nav-point", `sub-nav-point--${color}`, className)}
  >
    {children}
  </NavigationLink>
);

export default SubNavPoint;
